module.exports = __webpack_public_path__ + "img/明细.6687a061.png";